import { atom } from 'recoil';
import { EBottomBarActiveItem } from 'components-new/eCommerce/BottomBar/types';

export const activeItemState = atom<EBottomBarActiveItem>({
  key: 'activeItemState',
  default: EBottomBarActiveItem.cart,
});

export const bottomBarOpenState = atom({
  key: 'bottomBarOpenState',
  default: false,
});

export const sidebarMinimizedState = atom({
  key: 'sidebarMinimizedState',
  default: true,
});

export const sidebarOpenState = atom({
  key: 'sidebarOpenState',
  default: false,
});

export const youtubeOnState = atom({
  key: 'youtubeOnState',
  default: false,
});
